//React
import React from "react";
import PropTypes from "prop-types";
//CSS
import "./inputs.scss";

const ToggleSwitch = ({ id, label, showLabel, optionEnabled, optionDisabled, size, disabled, required, checked, onInput, info }) => {
	const wrapperClasses = [
		"input-wrapper",
		required ? "required" : "not-required",
	];
	return (
		<div className={wrapperClasses.join(" ")}>
			{label && (showLabel ?? false) ? (
				<label className={(disabled ?? false) && !(checked ?? false) ? "label-disabled" : "label-enabled"}>{label}</label>
			) : (
				""
			)}{" "}
			<div
				className={`${optionDisabled && optionEnabled ? "labeled" : "no-label"} ${size} ${
					(disabled ?? false) && !(checked ?? false) ? "toggle-disabled" : "toggle-enabled"
				} toggle-switch`}
			>
				<input
					disabled={disabled ?? false}
					type="checkbox"
					className="checkbox"
					name={id}
					id={id}
					checked={checked ?? false}
					onChange={(e) => onInput ? onInput(e.target.checked) : null}
				/>
				<label
					className="label"
					htmlFor={id}
				>
					<span
						className="inner"
						data-enabled={optionEnabled ?? ""}
						data-disabled={optionDisabled ?? ""}
					/>
					<span className="switch" />
				</label>
			</div>
			{info ? <div className="input-info">{info}</div> : ""}
		</div>
	);
};

ToggleSwitch.propTypes = {
	label: PropTypes.string.isRequired,
	size: PropTypes.oneOf(["sm", "lg"]).isRequired,
	id: PropTypes.string.isRequired,
	showLabel: PropTypes.bool,
	optionEnabled: PropTypes.string,
	optionDisabled: PropTypes.string,
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	checked: PropTypes.bool,
	onInput: PropTypes.func,
	info: PropTypes.string,
};

export default ToggleSwitch;
